import React from 'react';
import logo from '../../images/logo_purple.png';
// import { CustomLabel } from "@tracknme/material-ui";
import boxStep9 from '../../images/boxStep9.png';
import '../../mobile.css';

function Step9() {

  return (
    <div className="menuMobile">
        <div className="containerMobile">
        
            <div className="containerImage" >
                <img src={logo} className="logo" alt="Trackn'Me" />
            </div>
      
            <div className="containerNick" >
              <img src={boxStep9} className="nickMobileStep8" alt="nick" />
            </div>
      
        </div>
        
     </div>
    
  );
}

export default Step9;

